export default {
    ["AUTH_REQUEST"]: (state) => {
        state.status = "loading";
    },
    ["AUTH_SUCCESS"]: (state, { token, user, role }) => {
        state.status = "success";
        state.token = token;
        state.user = user;
        state.role = role;
    },
    ["AUTH_LOGOUT"]: (state) => {
        state.status = "";
        state.token = "";
    },
    ["AUTH_ERROR"]: (state) => {
        state.status = "error";
    },
};
